export default async function useRefreshToken() {
  const log = useLogger('composable:useRefreshToken')
  const supabase = useSupabaseClient()

  const sbAccessToken = useCookie('sb-access-token')
  const sbRefreshToken = useCookie('sb-refresh-token')

  try {
    const { data, error } = await supabase.auth.refreshSession()

    if (error) {
      log.error('Error refreshing session:', error)
      return
    }

    if (data.session) {
      sbAccessToken.value = data.session.access_token
      sbRefreshToken.value = data.session.refresh_token
    }
  }
  catch (error) {
    log.error('Error refreshing session:', error)
  }
}
